export class UsoPlazaModel {

  idRegulacion: number;
  rotaciones: number;
  tiempoMedio: number;
  ocupacionMediaSemanal: number;
  nivelDisponibilidadLibreSemanal: number;
  alertasTiempoExcedido: number;
  alertasAvisoProximo: number;
}
